import React, { useEffect, useState } from "react";
import { Header } from "../common/Header";
import { Menunav } from "../common/Menunav";
import { Sidebar } from "../common/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import api from "../../utils/api";
// import {Link } from 'react-router-dom';
import "../projects/projects.css";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";

export const Listnew = () => {
  const [FYPs, setFYPs] = useState([]);
  useEffect(() => {
    api
      .get("/FYPs/new")
      .then((res) => {
        setFYPs(res.data);
        console.log("res>", res.data);
        // let array = res.data;
        // let temp = res.data;
        // var n = array.length;
        // var j = 0;
        // for (var i = 0; i < 40; i++) {
        //   if (j === n) {
        //     i = 0;
        //   }
        //   array.push(temp[j]);
        //   j++;
        // }
        // setFYPs(array);
      })
      .catch((err) => console.log);
  }, []);
  const [itemsPerPage, setItemsPerPage] = useState(9);
  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(FYPs.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(FYPs.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, FYPs]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % FYPs.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };

  return (
    <div>
      {/* <Header />
      <Menunav /> */}
      <div className="row">
        {/* <div className="col-md-2 col-0">
          <Sidebar />
        </div> */}
        <div className="col-md-12 col-12">
          {/* <div className="conainer my-4">
            <h3>List of New Projects:</h3>
          </div> */}
          <div className="container-fluid">
            {FYPs?.length > 0 ? (
              FYPs?.sort(function (a, b) {
                return new Date(b.updatedAt) - new Date(a.updatedAt);
              }).map((f) => <Item2 fyp={f} />)
            ) : (
              <></>
            )}
            {/* <table className="table see-already-table">
              <thead>
                <th>Project</th>
                <th>Project Type</th>

                <th>Date Posted</th>
                <th>View</th>
              </thead>
              <tbody>
                <Items currentItems={FYPs} setCurrentItems={setCurrentItems} />
              </tbody>
            </table> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export function Item2({ fyp }) {
  const [uploader, setUploader] = useState("");
  useEffect(() => {
    // console.log("hostel", sch);
    fyp?.userId &&
      api
        .get(`/user/getUserdataById/` + fyp?.userId)
        .then((res) => {
          console.log("user of list new", res?.data);
          setUploader(res?.data);
        })
        .catch((err) => console.log("err", err));
  }, [fyp]);
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const navigate = useNavigate();
  useEffect(() => {
    console.log("current  item ", fyp);
  }, []);
  const deleteFYP = (f) => {
    api
      .delete(`/FYPs/${f?._id}`)
      .then((res) => {
        if (res.data) {
          let notifBody = {
            userId: currentUser?.id,
            text: `Admin delete your FYP for violating terms and conditions.`,
            forAll: false,
            receiverId: f?.userId,
          };
          api
            .post("/notifications", notifBody)
            .then((re) => console.log("notif", re.data));
          window.location.reload();
        }
      })
      .catch((err) => console.log);
  };
  return (
    <>
      <Card sx={{ width: "100%", marginBottom: "30px" }}>
        <CardHeader
          onClick={() => navigate(`/user-profile/${fyp?.userId}`)}
          className="title__link"
          avatar={
            <Stack direction="column">
              {uploader?.profile ? (
                <Avatar
                  src={uploader?.profile}
                  alt={uploader?.name?.at(0)?.toUpperCase()}
                />
              ) : (
                <Avatar sx={{ bgcolor: "colorThree.main" }} aria-label="recipe">
                  {uploader?.name?.at(0)?.toUpperCase()}
                </Avatar>
              )}
            </Stack>
          }
          // action={
          //   <IconButton aria-label="settings">
          //     <MoreVertIcon />
          //   </IconButton>
          // }
          title={uploader?.name?.toUpperCase()}
          subheader={new Date(fyp?.createdAt).toDateString()}
        />
        {/* {hostel?.hostelImage && (
                <CardMedia
                  component="img"
                  height="50"
                  width="50"
                  image={hostel?.hostelImage}
                  alt="Paella dish"
                />
              )} */}
        <CardContent sx={{ marginTop: "-20px" }}>
          <Box
            sx={{
              boxShadow: "none",
              padding: "20px 0",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                textTransform: "whitesmoke",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              {fyp?.title}
            </Typography>
            <Grid container gap={1} sx={{ marginTop: "20px" }}>
              <Grid item xs={12} lg={12}>
                <Grid container gap={6}>
                  <Grid
                    item
                    xs={10}
                    lg={5}
                    sx={{
                      display: "flex",
                      gap: "10px",
                      flexDirection: "column",
                      marginTop: { xs: "20px", lg: "0" },
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {" "}
                      <Typography
                        variant="body2"
                        sx={{
                          width: "150px",
                          fontWeight: "600",
                          color: "#777",
                        }}
                      >
                        Type
                      </Typography>
                      <Typography variant="body2">
                        {fyp?.projectType}
                      </Typography>
                    </Box>

                    {/* <Box sx={{ display: "flex" }}>
                    <Typography
                      variant="body2"
                      sx={{
                        width: "120px",
                        fontWeight: "600",
                        color: "#777",
                      }}
                    >
                      <CallIcon sx={{ color: "gray", marginRight: "5px" }} />
                      Contact
                    </Typography>
                    <Typography variant="body2">
                      {inte?.generalData?.contact}
                    </Typography>
                  </Box> */}
                  </Grid>
                  <Grid
                    item
                    xs={10}
                    lg={5}
                    sx={{
                      display: "flex",
                      gap: "10px",
                      flexDirection: "column",
                    }}
                  >
                    <Box sx={{ display: "flex" }}>
                      <Typography
                        variant="body2"
                        sx={{
                          width: "120px",
                          fontWeight: "600",
                          color: "#777",
                        }}
                      >
                        Technology
                      </Typography>
                      <Typography variant="body2">
                        {fyp?.techUsed ? fyp?.techUsed : "N/A"}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
                <Box sx={{ display: "flex" }}>
                  <Typography
                    variant="body2"
                    sx={{
                      width: "150px",
                      fontWeight: "600",
                      color: "#777",
                      marginTop: "10px",
                    }}
                  >
                    Related Work
                  </Typography>
                  <Typography
                    variant="body2"
                    className="title__link"
                    sx={{ maxWidth: "200px", marginTop: "10px" }}
                  >
                    <a href={fyp?.projectLink}> {fyp?.projectLink} </a>
                  </Typography>
                </Box>
                {fyp?.description && (
                  <>
                    <Typography
                      variant="body2"
                      sx={{
                        width: "150px",
                        fontWeight: "600",
                        color: "#777",
                        marginTop: "20px",
                      }}
                    >
                      Description
                    </Typography>
                    <Box>
                      <Typography variant="body2">
                        {fyp?.description}
                      </Typography>
                    </Box>
                  </>
                )}

                {currentUser?.isAdmin && (
                  <td className="delete" onClick={() => deleteFYP(fyp)}>
                    <DeleteOutlineIcon />
                  </td>
                )}
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
      {/* <>
        {currentItems &&
          currentItems
            .sort(function (a, b) {
              return new Date(b.updatedAt) - new Date(a.updatedAt);
            })
            .map((f, i) => (
              <tr>
               
                <td style={{ maxWidth: "200px" }}>
                  <Typography sx={{ fontSize: "0.875rem", fontWeight: "600" }}>
                    {f?.title}
                  </Typography>
                  <Typography sx={{ fontSize: "0.75rem" }}>
                    {f?.description}
                  </Typography>
                </td>
                <td style={{ maxWidth: "150px" }}>
                  <Typography sx={{ fontSize: "0.875rem" }}>
                    {f?.projectType}
                  </Typography>
                </td>
                <td>
                  <Typography sx={{ fontSize: "0.875rem" }}>
                    {new Date(f?.createdAt).toDateString()}
                  </Typography>
                </td>
                <td>
                  
                  <a href={f?.projectLink}>
                    <i className="fa fa-eye"></i>
                  </a>
                </td>
                {currentUser?.isAdmin && (
                  <td className="delete" onClick={() => deleteFYP(f)}>
                    <DeleteOutlineIcon />
                  </td>
                )}
              </tr>
            ))}
      </> */}
    </>
  );
}
